import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import axios from "axios";
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "./DatasourceBaseTextFields.jsx";

const DatasourceKolibriLIVE = (props) => {

    const [mRepainter, SetRepainter] = useState(false); 
    
    useEffect(() => {
        SetReady()
        SetRepainter(!mRepainter)
        }, []); 
        
    const UpdateDatasourceSetting = (aNewValue, aIdentifier) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aNewValue

        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady((props.IntegrationSettings.DatasourceSettings.RealEstateAgencyId ? true : false))
    }
    
    return (
        <div className="scriptitembody">

            <div className="wizardfieldname">{Translate("RealEstateAgency ID").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue"><input autoComplete="KolibriRealEstateAgencyId" type="text" value={props.IntegrationSettings.DatasourceSettings.RealEstateAgencyId || ""} onChange={evt => UpdateDatasourceSetting(evt.target.value, "RealEstateAgencyId")} className="wizardinputfield"/></div>
            
            <br/>
            
            <table cellPadding="2">
            <tbody>
                <tr>
                    <td width="30"><span className="checkbox-wrapper-13"><input type="checkbox" checked={props.IntegrationSettings.DatasourceSettings.SandboxEnvironment ? "checked" : ""} onChange={evt => UpdateDatasourceSetting(evt.target.checked, "SandboxEnvironment")}/></span></td>
                    <td width="*">{Translate("Sandbox Environment")}</td>
                </tr>
            </tbody>
            </table>
        </div>
    );
}

DatasourceKolibriLIVE.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceKolibriLIVE